import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivGridContainer = styled.div`
  display: grid;
  grid-gap: 16px;
`;

export const ParMainText = styled.p`
  font-size: 14px;
`;

export const ParSubText = styled.p`
  font-size: 14px;
  color: ${COLOR.GRAY500.code};
`;
